import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { ElementType } from "react";
import { UserView } from "@my-helpers/common";

interface DeleteUserProps {
    userToDelete: UserView | null;
    deleteDialogOpen: boolean;
    deleteUser: (userId: string) => Promise<boolean>;
    setDeleteDialogOpen: (open: boolean) => void;
    setUserToDelete: (user: UserView | null) => void;
}

const DeleteUser: ElementType<DeleteUserProps> = ({
    userToDelete,
    deleteDialogOpen,
    deleteUser,
    setDeleteDialogOpen,
    setUserToDelete
}) => {
    const handleDeleteConfirm = async () => {
        if (!userToDelete?.id) return;
        
        await deleteUser(userToDelete.id);
        
        setDeleteDialogOpen(false);
        setUserToDelete(null);
    };

    const handleDeleteCancel = () => {
        setDeleteDialogOpen(false);
        setUserToDelete(null);
    };

    return (
        <Dialog open={deleteDialogOpen} onClose={handleDeleteCancel}>
            <DialogTitle>Delete User</DialogTitle>
            <DialogContent>
                <Typography>
                    Are you sure you want to delete "{userToDelete?.givenName + ' ' + userToDelete?.familyName}"?
                    This action cannot be undone.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleDeleteCancel}>Cancel</Button>
                <Button onClick={handleDeleteConfirm} color="error" variant="contained">
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteUser;
